import * as M from "@discovery/prelude/lib/data/maybe";
import styles from "./breakpoints.css";
import { readFloat } from "../utils/number";
/**
 * mobile stops at 767px, tablet starts at 768px
 * tablet stops at 1023px, desktop starts at 1024px
 * desktop stops at 1439px, cinema starts at 1440px
 */
export const sizePx = {
    xsmall: M.fromMaybe(readFloat(styles.mediaBreakXsmall), 480),
    small: M.fromMaybe(readFloat(styles.mediaBreakSmall), 768),
    medium: M.fromMaybe(readFloat(styles.mediaBreakMedium), 1024),
    large: M.fromMaybe(readFloat(styles.mediaBreakLarge), 1440),
    xlarge: M.fromMaybe(readFloat(styles.mediaBreakXlarge), 1600),
    short: M.fromMaybe(readFloat(styles.mediaBreakShort), 480),
};
export const marginVw = {
    mobile: M.fromMaybe(readFloat(styles.marginMobile), 6.4),
    tablet: M.fromMaybe(readFloat(styles.marginTablet), 5.2083),
    desktop: M.fromMaybe(readFloat(styles.marginDesktop), 4.5),
    cinema: M.fromMaybe(readFloat(styles.marginCinema), 3.5),
};
export const gapVw = {
    mobile: M.fromMaybe(readFloat(styles.gapMobile), 3.2),
    tablet: M.fromMaybe(readFloat(styles.gapTablet), 1.5625),
    desktop: M.fromMaybe(readFloat(styles.gapDesktop), 1.25),
    cinema: M.fromMaybe(readFloat(styles.gapCinema), 1),
};
export const media = {
    xsmall: {
        up: `(min-width: ${sizePx.xsmall}px)`,
        down: `(max-width: ${sizePx.xsmall - 1}px)`,
    },
    small: {
        up: `(min-width: ${sizePx.small}px)`,
        down: `(max-width: ${sizePx.small - 1}px)`,
    },
    medium: {
        up: `(min-width: ${sizePx.medium}px)`,
        down: `(max-width: ${sizePx.medium - 1}px)`,
    },
    large: {
        up: `(min-width: ${sizePx.large}px)`,
        down: `(max-width: ${sizePx.large - 1}px)`,
    },
    xlarge: {
        up: `(min-width: ${sizePx.xlarge}px)`,
        down: `(max-width: ${sizePx.xlarge - 1}px)`,
    },
    mobileOnly: `(max-width: ${sizePx.small}px)`,
    tabletOnly: `(min-width: ${sizePx.small}px) and (max-width: ${sizePx.medium}px)`,
    desktopOnly: `(min-width: ${sizePx.medium}px) and (max-width: ${sizePx.large}px)`,
    cinemaOnly: `(min-width: ${sizePx.large}px) and (max-width: ${sizePx.xlarge}px)`,
    /* short is used for mobile screen size with max-height 480px; which is for landscape view */
    short: `(max-height: ${sizePx.short}px)`,
};

